// import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';

import DateUtil from "../disponibilidade/DateUtil";

const INITIAL_STATE = {
  tarefas: [],
  agendamentos: [],
  agendamentosBI: [],
  loadingTarefas: false,
  loadingAgendamentos: false,
  loadingAgendamentosBI: false,
  loadingComprovante: false,
  filterStatus: { id: 1, label: "Todos", status: null },
  filterProtocolo: "",
  filterAno: DateUtil.getCurrentYear(),
  totalRequerimentos: 0,
  requerimentoSelecionado: null,
  showModalAvisoExigencia: false,
  refreshTarefas: 0,
  lastRefreshTarefa: 0,
  erroConsultarTarefas: false,
  erroConsultarAgendamentos: false,
  erroConsultarAgendamentosBI: false,
  errorMessage: null,
  mensagem: '',

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQUERIMENTO_CONSULTA_INICIAR_TAREFAS":
      return { ...state, loadingTarefas: true };
    case "REQUERIMENTO_CONSULTA_FIM_TAREFAS":
      return { ...state, loadingTarefas: true };
    case "REQUERIMENTO_CONSULTA_INICIAR_AGENDAMENTO":
      return { ...state, loadingAgendamentos: true };
    case "REQUERIMENTO_CONSULTA_INICIAR_AGENDAMENTO_BI":
        return { ...state, loadingAgendamentosBI: true };
    case "REQUERIMENTO_CONSULTA_TAREFA_SUCESSO":
      return {
        ...state,
        tarefas: Array.isArray(action.payload) ? action.payload : state.tarefas,
        loadingTarefas: false, refreshTarefas: 0
      };
    case "REQUERIMENTO_CONSULTA_AGENDAMENTO_SUCESSO":
      return {
        ...state,
        agendamentos: Array.isArray(action.payload)
          ? action.payload
          : state.agendamentos,
        loadingAgendamentos: false,
        erroConsultarAgendamentos: false
      };
      case "REQUERIMENTO_CONSULTA_AGENDAMENTO_BI_SUCESSO":
        return {
          ...state,
          agendamentosBI: Array.isArray(action.payload)
            ? action.payload
            : state.agendamentosBI,
            loadingAgendamentosBI: false,
            erroConsultarAgendamentos: false
        };
    case "REQUERIMENTO_CONSULTA_TAREFA_ERRO":
      return { ...state, loadingTarefas: false, erroConsultarTarefas: true };
    case "REQUERIMENTO_CONSULTA_AGENDAMENTO_ERRO":
      return { ...state, loadingAgendamentos: false, erroConsultarAgendamentos: true };
    case "REQUERIMENTO_CONSULTA_AGENDAMENTO_BI_ERRO":
        return { ...state, loadingAgendamentosBI: false, erroConsultarAgendamentosBI: true };
    case "REQUERIMENTO_CONSULTA_FILTER_STATUS":
      return { ...state, filterStatus: action.payload };
    case "REQUERIMENTO_CONSULTA_FILTER_PROTOCOLO":
      return { ...state, filterProtocolo: action.payload };
    case "REQUERIMENTO_CONSULTA_FILTERS":
      const { protocolo, status, ano } = action.payload;
      return { ...state, filterProtocolo: protocolo, filterStatus: status, filterAno: ano};
    case "REQUERIMENTO_CONSULTA_INICIA_COMPROVANTE":
      return { ...state, loadingComprovante: true };
    case "REQUERIMENTO_CONSULTA_INICIA_LAUDO":
      return { ...state, loadingComprovante: true };
    case "REQUERIMENTO_CONSULTA_RELATORIO_TAREFA_SUCESSO":
      return { ...state, loadingComprovante: false, mensagem: 'sucesso' };
    case "REQUERIMENTO_CONSULTA_COMPROVANTE_AGENDAMENTO_SUCESSO":
      return { ...state, loadingComprovante: false, mensagem: 'sucesso' };
    case "REQUERIMENTO_CONSULTA_COMPROVANTE_TAREFA_SUCESSO": 
      return { ...state, loadingComprovante: false, mensagem: 'sucesso' };
    case "REQUERIMENTO_CONSULTA_RELATORIO_LAUDO_SUCESSO":
      return { ...state, loadingComprovante: false };
    case "REQUERIMENTO_CONSULTA_COMPROVANTE_AGENDAMENTO_ERROR":
        return { ...state, loadingComprovante: false, mensagem: 'error' };
    case "REQUERIMENTO_CONSULTA_COMPROVANTE_TAREFA_ERROR":
        return { ...state, loadingComprovante: false, mensagem: 'error' };
    case "REQUERIMENTO_CONSULTA_RELATORIO_TAREFA_ERROR":
        return { ...state, loadingComprovante: false, mensagem: 'error' };
    case "REQUERIMENTO_CONSULTA_RELATORIO_LAUDO_ERROR":
      return { ...state, loadingComprovante: false, errorMessage: action.payload };
    case "REQUERIMENTO_CONSULTA_EXIBIR_AVISO_EXIGENCIA":
      return {
        ...state,
        showModalAvisoExigencia: true,
        requerimentoSelecionado: action.payload,
      };
    case "REQUERIMENTO_CONSULTA_OCULTAR_AVISO_EXIGENCIA":
      return { ...state, showModalAvisoExigencia: false };
    case "REQUERIMENTO_CONSULTA_REFRESH_TAREFAS":
      return { ...state, refreshTarefas: state.refreshTarefas + 1 };
    case "REQUERIMENTO_CONSULTA_RESET_ERROS":
      return {
        ...state, 
        erroConsultarTarefas: false, 
        erroConsultarAgendamentos: false, 
        erroConsultarAgendamentosBI: false,
        errorMessage: null
      }
    case "REQUERIMENTO_CONSULTA_RESET_REDUX":
      return INITIAL_STATE;
    case "LIMPA_MENSAGEM_REQUERIMENTO_CONSULTA":
      return { ...state, mensagem: '' };
    default:
      return state;
  }
};
